import { z } from "zod";
import { createEndpoint } from "../createEndpoint";
import type { HttpClient, QueryParams } from "../httpClient";
import {
    AdminSettingSchema,
    UpdateAdminSettingsRequestSchema,
} from "../schemas/admin-settings";

export interface AdminSettingsListQueryParams extends QueryParams {
    q?: string;
    groups?: string[];
}

export function createAdminSettingsApi(http: HttpClient, baseUrl: string) {
    const adminSettingsBaseUrl = `${baseUrl}/admin/settings`;
    const settingsResponseSchema = z.array(AdminSettingSchema);

    return {
        list: createEndpoint<
            z.infer<typeof settingsResponseSchema>,
            unknown,
            AdminSettingsListQueryParams
        >(http, "GET", "", {
            base: adminSettingsBaseUrl,
            responseSchema: settingsResponseSchema,
        }),

        update: createEndpoint<
            z.infer<typeof settingsResponseSchema>,
            z.input<typeof UpdateAdminSettingsRequestSchema>
        >(http, "PUT", "", {
            base: adminSettingsBaseUrl,
            responseSchema: settingsResponseSchema,
        }),
    };
}

export type AdminSettingsApi = ReturnType<typeof createAdminSettingsApi>;
